import { APIURL } from "./config";
import axios from "axios";
import { toast } from "react-toastify";
import { FLEET_LIST, FLEET_ADD, FLEET_UPDATE, FLEET_DELETE, LOADING, NOT_FOUND } from "./type";

export const fleetList = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: ''
  })
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/fleets`, config);
    dispatch({
      type: FLEET_LIST,
      payload: res.data,
    });
    if (res?.data?.data?.fleet?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: '',
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const addFleet = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    name: val.name,
    image: val.image,
    vehicle_model: val.vehicle_model,
    year: val.year,
    color: val.color,
    registration_no: val.registration_no,
    fuel_type: val.fuel_type,
    license_plate: val.license_plate,
    status: val?.status,
  });
  try {
    const response = await axios.post(`${APIURL}/api/v1/fleets`, body, config);
    dispatch({ type: FLEET_ADD, payload: response?.data });
    toast.success("Fleet Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-fleet");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateFleet = (val, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const body = JSON.stringify({
    name: val?.name,
    image: val.image,
    vehicle_model: val?.vehicle_model,
    year: val?.year,
    color: val?.color,
    registration_no: val?.registration_no,
    fuel_type: val?.fuel_type,
    license_plate: val?.license_plate,
    status: val?.status,
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/fleets/${id}`,
      body,
      config
    );
    dispatch({ type: FLEET_UPDATE, payload: response?.data });
    toast.success("Fleet Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-fleet");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const fleetDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete fleet")) {
      const res = await axios.delete(`${APIURL}/api/v1/fleets/${id}`, config);
      toast.success("Fleet Deleted Successfully!");
      dispatch({
        type: FLEET_DELETE,
        payload: res.data,
      });

      return { success: true }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateFleetStatus = (id, oldFleetId) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    status: "busy",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/fleets/${id}`,
      body,
      config
    );
    if (response.data.status == "success" && oldFleetId !== undefined) {
      dispatch(enableFleetStatus(oldFleetId));
    }

    dispatch({ type: FLEET_UPDATE, payload: response?.data });
    // toast.success("Update successfully!");
    // setTimeout(() => {
    //   return (window.location.href = "/manage-fleet");
    // }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
export const enableFleetStatus = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    status: "available",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/fleets/${id}`,
      body,
      config
    );
    dispatch({ type: FLEET_UPDATE, payload: response?.data });
    // toast.success("Update successfully!");
    // setTimeout(() => {
    //   return (window.location.href = "/manage-fleet");
    // }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const multiFleetDelete = (id) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow",
  };
  const label = id?.length > 1 ? "Fleets" : "Fleet";
  if (window.confirm(`Do you want to delete the selected ${label.toLowerCase()}?`)) {
    fetch(`${APIURL}/api/v1/fleets/delete/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success(`${label} Deleted Successfully!`);
        }
      })
      .catch((error) => console.log("error", error));
  }
};
